<template>
	<v-row>
		<v-col cols="8" class="pt-0 pb-0 pr-1">
			<DatePicker :dateLabel="dateLabel" :error-border="errorBorder" :error="error" :readonly="readonly" v-model="selectedValue.date"/>
		</v-col>
		<v-col cols="4" class="pl-1 pt-0 pb-0">
			<v-text-field
				dense
				:error="errorBorder || (error !== '')"
				:hide-details="hideDetails"
				:label="timeLabel"
				:mask="'##:##:##'"
				:readonly="readonly"
				:rules="[rules.time]"
				outlined
				return-masked-value
				v-model="selectedValue.time"
				:placeholder="'__:__:__'"
			></v-text-field>
		</v-col>
	</v-row>
</template>

<script>
import DatePicker from "./DatePicker";

export default {
	name: "DateTimePicker",
	components: {DatePicker},
	props: {
		readonly: Boolean,
		value: [Object, String],
		dateLabel: String,
		timeLabel: String,
		errorBorder: {
			type: Boolean,
			default: false
		},
		error: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			selectedValue: {
				date: null,
				time: null
			},
			rules: {
				time: value => {
					return this.$timePattern.test(value) || 'hh:mm:ss'
				}
			}
		}
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				this.setValue(newVal);
			}
		},
		selectedValue: {
			handler: function () {
				let newValue = null;
				if ((this.selectedValue.date != null) && (this.selectedValue.time != null)) {
					newValue = this.selectedValue.date + ' ' + this.selectedValue.time;
				}
				if (newValue != null) {
					if (newValue != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', newValue);
						})
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					})
				}
			},
			deep: true
		}
	},
	methods: {
		setValue(newVal) {
			if (newVal != null) {
				const [date, time] = newVal.split(' ');
				this.selectedValue.date = date;
				this.selectedValue.time = time;
			} else {
				this.selectedValue.date = null;
				this.selectedValue.time = null;
			}
		}
	},
	mounted() {
		this.setValue(this.$props.value);
	}
}
</script>

<style scoped>

</style>
